import { useModuleBEM, useTenantImages } from "@b2bportal/core-themes";

import styles from "./RoomCardSkeleton.module.scss";
import { Shimmer } from "@/components";

const HotelsShopPageHotelRoomCardSkeleton = () => {
  const [block, cn] = useModuleBEM(styles, "RoomCardSkeleton");

  const images = useTenantImages();

  return (
    <div className={block}>
      <Shimmer height={250} className={cn("image-container")}>
        <img
          className={cn("image")}
          alt="loading"
          src={images.roomPlaceholder}
        />
      </Shimmer>
      <div className={cn("content")}>
        <Shimmer height={20} />
        <Shimmer width={140} height={20} />
        <Shimmer height={20} />
        <Shimmer height={20} />

        <Shimmer height={20} className={cn("spaced")} />
        <Shimmer height={20} />
        <Shimmer width={140} height={20} />

        <Shimmer height={40} className={cn("room-select-button")} />
      </div>
    </div>
  );
};

export default HotelsShopPageHotelRoomCardSkeleton;
